import { render, staticRenderFns } from "./login.vue?vue&type=template&id=0c6e2d28&scoped=true&"
import script from "./login.vue?vue&type=script&scoped=true&lang=js&"
export * from "./login.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=0c6e2d28&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e2d28",
  null
  
)

export default component.exports